import 'core-js/es/array';
import 'core-js/es/promise';
import 'core-js/es/object';

if (!String.prototype.includes) {
    String.prototype.includes = function (search, start) {
        'use strict';
        if (typeof start !== 'number') {
            start = 0;
        }

        if (start + search.length > this.length) {
            return false;
        } else {
            return this.indexOf(search, start) !== -1;
        }
    };
}

declare global {
    interface Element {
        msMatchesSelector: any;
    }
}

if (!Element.prototype.matches) {
    Element.prototype.matches =
        Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function (s: any) {
        var el = this;

        do {
            if (Element.prototype.matches.call(el, s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}


(function () {

    if (typeof ((window as any).CustomEvent) === "function") return false;

    function CustomEvent(event: any, params: any) {
        params = params || { bubbles: false, cancelable: false, detail: null };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    (window as any).CustomEvent = CustomEvent;
})();

import 'abortcontroller-polyfill/dist/polyfill-patch-fetch';